var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 289,
    viewBox: "0 0 335 289",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.527 286.327C109.918 278.105 71.4177 260.801 35.0114 229.026C-30.4977 171.85 5.39321 72.8607 81.2404 30.3432L127.978 4.14341C159.447 -13.497 195.698 -20.7074 231.522 -16.4517L276.956 -11.0545C318.531 -6.11559 355.636 17.378 377.881 52.8475L393.346 77.5055C411.539 106.515 411.9 143.285 394.28 172.646C381.196 194.448 359.584 209.779 334.683 214.922L312.059 219.595C289.746 224.204 268.849 234.055 251.095 248.334L238.785 258.235C211.202 280.417 176.848 294.981 142.527 286.327Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlop);
export default __webpack_public_path__ + "static/media/blop.97e67226.svg";
export { ForwardRef as ReactComponent };